import { render, staticRenderFns } from "./financeDashboard.vue?vue&type=template&id=ec3825a6&scoped=true&"
import script from "./financeDashboard.vue?vue&type=script&lang=js&"
export * from "./financeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./financeDashboard.vue?vue&type=style&index=0&id=ec3825a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3825a6",
  null
  
)

export default component.exports